import { postJSON } from '../utils/json';

export default ({ eventsBaseURL }) => {
    return {
        async postToSift(data) {
            return await postJSON(`${eventsBaseURL}/sift`, data);
        },
    };
};
